// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-main {
    background-color: #0D1723;
    padding:16px 22px
}

/* .sidebar-main {
    width: 180px;
    background-color: black;
    padding: 16px 32px;
    position: sticky;
    top: 12px;
    height: 100vh;
    overflow-y: auto;
    overflow: hidden;
} */

.sidebar-main {
  position: sticky;
  top: 70px;
  left: 0;
  width: 250px;
  height: calc(100vh - 70px);
  overflow-y: auto;
}

.sidebar-main::-webkit-scrollbar {
    display: none;
}

.sidebar-main h6{
    color: rgb(170, 170, 170);
    font-weight: 600;
 }
.sidebar-options {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin-top: 16px;
}
.category-name{
    display: flex;
    align-items: center;
    column-gap: 8px;
}
.sidebar-name {
    margin: 12px 0;
    color: #ddd;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px;
    border-radius: 8px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out;
}

.subcategory-name {
    margin: 12px 0;
    color: #ddd;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px;
    border-radius: 8px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out;
}
.subcategory-name.selected {
    border: 2px solid white;
    color: white;
  }

.sidebar-name:hover {
    transform: scale(1.05);
}

.sidebar-name p {
    margin: 0;
    font-size: 14px;
    font-weight: bold;
    color: #ddd;
}

.sidebar-name.selected {
    border: 2px solid white;
    color: white;
  }
  
  .sidebar-name.selected p {
    font-weight: 700; /* Bold text for the selected option */
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB;AACJ;;AAEA;;;;;;;;;GASG;;AAEH;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;CACnB;AACD;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;AACA;IACI,uBAAuB;IACvB,YAAY;EACd;;AAEF;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,gBAAgB,EAAE,sCAAsC;EAC1D","sourcesContent":[".sidebar-main {\n    background-color: #0D1723;\n    padding:16px 22px\n}\n\n/* .sidebar-main {\n    width: 180px;\n    background-color: black;\n    padding: 16px 32px;\n    position: sticky;\n    top: 12px;\n    height: 100vh;\n    overflow-y: auto;\n    overflow: hidden;\n} */\n\n.sidebar-main {\n  position: sticky;\n  top: 70px;\n  left: 0;\n  width: 250px;\n  height: calc(100vh - 70px);\n  overflow-y: auto;\n}\n\n.sidebar-main::-webkit-scrollbar {\n    display: none;\n}\n\n.sidebar-main h6{\n    color: rgb(170, 170, 170);\n    font-weight: 600;\n }\n.sidebar-options {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 16px;\n    margin-top: 16px;\n}\n.category-name{\n    display: flex;\n    align-items: center;\n    column-gap: 8px;\n}\n.sidebar-name {\n    margin: 12px 0;\n    color: #ddd;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 8px;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: transform 0.2s ease-in-out;\n}\n\n.subcategory-name {\n    margin: 12px 0;\n    color: #ddd;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 8px;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: transform 0.2s ease-in-out;\n}\n.subcategory-name.selected {\n    border: 2px solid white;\n    color: white;\n  }\n\n.sidebar-name:hover {\n    transform: scale(1.05);\n}\n\n.sidebar-name p {\n    margin: 0;\n    font-size: 14px;\n    font-weight: bold;\n    color: #ddd;\n}\n\n.sidebar-name.selected {\n    border: 2px solid white;\n    color: white;\n  }\n  \n  .sidebar-name.selected p {\n    font-weight: 700; /* Bold text for the selected option */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
